<template>
  <div>
    <el-dialog
        :title="dialogTitle"
        :visible="dialog"
        width="750px"
        top="3vh"
        :modal="true"
        :append-to-body="true"
        @close="close"
        @open="open"
    >
      <el-form ref="channel" :model="channel" label-position="top">
        <el-form-item label="Channel Id" prop="channel_id">
          <el-input type="text" v-model="channel.channel_id" clearable placeholder="Enter the channel id" />
        </el-form-item>
        <el-form-item label="Channel Associate User" prop="label">
          <el-select class="mt10" v-model="channel.manager_user_id" clearable filterable style="width: 100%">
            <el-option
                v-for="manager in mcn_managers"
                :key="manager.username"
                :value="manager.id"
                :label="`${manager.username}`"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Report Type" prop="report_type">
          <el-select v-model="channel.report_type" clearable style="width: 100%">
            <el-option
                v-for="type in reportTypes"
                :key="type.value"
                :label="type.label"
                :value="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <p class="danger" v-if="channel_id_valid === false">YouTube channel ID is not valid</p>
      <p class="success" v-if="channel_id_valid === true">YouTube channel ID is valid</p>
      <div v-if="channel_info.channelId" class="channel-info">
        <img :src="channel_info.image_url" alt="">
        <p><strong>ID: </strong> {{channel_info.channelId}}</p>
        <p><strong>Title: </strong> {{channel_info.title}}</p>
      </div>
      <div slot="footer">
        <el-button
            type="warning"
            size="mini"
            :loading="loading"
            @click="check()"
        >
          Check Channel
        </el-button>
        <el-button
            :disabled="!channel_id_valid"
            type="primary"
            size="mini"
            :loading="loading"
            @click="submit('channel')"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from "vue2-editor"
import Preview from '@/global/components/Preview'

export default {
  components: {
    Preview
  },
  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      reportTypes: [
        { label: "MCN", value: 2 },
        { label: "Label", value: 1 }
      ]
    }
  },

  computed: {
    dialogTitle: function() {
      return 'Insert channel id and select channel associate user'
    },
    ...mapState('mcnChannels', [
      'loading',
      'channel',
      'data',
      'dialog',
      'mcn_managers',
      'channel_info',
      'channel_id_valid'
    ])
  },

  methods: {
    ...mapActions('mcnChannels', ['insert', 'checkChannel', 'readMcnManagers']),
    ...mapMutations('mcnChannels', [
      'setSelectedchannel',
      'setDialog'
    ]),
    ...mapMutations('global', ['setPreview']),

    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (typeof this.channel.id !== 'undefined' && this.channel.id !== null)
            this.update(this.channel.id)
          else {
            this.insert().then(() => {
              this.resetForm()
            })
          }
        } else {
          return false
        }
      })
    },
    check() {
      this.checkChannel();
    },
    resetForm() {
      this.channel.channel_id = null
      this.channel.manager_user_id = null
      this.channel.report_type = null
    },
    open(){
      this.readMcnManagers()
    },
    close() {
      this.setDialog(false)
    }
  }
}
</script>

<style scoped>
.inline-eye {
  display: inline-block;
}
.channel-info {
  padding: 15px;
  text-align: center;
  img {
    border-radius: 100%;
  }
}
.success {
  color: #7dceaf;
  text-align: center;
  padding-top: 15px;
}
.danger {
  color: #d06e6e;
  text-align: center;
  padding-top: 15px;
}
</style>
